import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class EndCustomerStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
